import React, { createContext, useState, PropsWithChildren, Dispatch, SetStateAction } from 'react';

interface AddAvailabilityProps {
    locationId: string;
    unitId: string;
    setLocationId: Dispatch<SetStateAction<string>>;
    setUnitId: Dispatch<SetStateAction<string>>;
}

export const AddAvailabilityContext = createContext<AddAvailabilityProps | null>(null);

export const AddAvailabilityProvider = ({ children }: PropsWithChildren<object>) => {
    const [locationId, setLocationId] = useState('');
    const [unitId, setUnitId] = useState('');

    return (
        <AddAvailabilityContext.Provider value={{ locationId, setLocationId, unitId, setUnitId }}>
            {children}
        </AddAvailabilityContext.Provider>
    );
};
